/**
 * 商城控制器
 */
import { restaurantConfig, mallMobx, doProductMobx, cartMobx, payPlanMobx, bankCardMobx, storeMobx, productMobx, shopcartCache, shopcartMobx } from 'mobx/mall'
import { orderMobx, orderListMobx } from 'restaurant'
import { payChannelMobx } from 'mobx/mall/payment'
import { isEmpty, filter, find, map, reject } from '@dt/fe-utils/dist/lodash'
import { store, toDecimal, uuid, getHandTopUrl, getCookie, setCookie } from '@dt/fe-utils'
import { handleEleScrollTo, getHistoryNew, modalLayer, getPlatform, miniAppRouteTo } from '@utils'
import scrollController from './scrollController'
import { memberMobx, payMobx, decorationMobx, surchargeMobx } from '@mobxStore'
import { GlobalPaymentsModal, ConfirmModal } from '@cps'
import appMobx from '@mobx/app/app.mobx'
import { PayApi, OrderAPI } from 'api'
import BankCardAuthModal from '@pages/checkout/modal/BankCardAuthModal'
import { apConfigG } from './third'
import ProductAPI from 'api/mallProduct.api'
import { ScaleModal } from '@pages/mall/product/modal'

let lazyLine = ''
let scst: any

/** 当前操作结算页来源 */
export enum TCheckoutType {
  Cart = 'cart', // 商城购物车
  Group = 'group', // 拼团
  Buy = 'buy', // 直接购买
}
/**
 * 商城瀑布流样式
 */
export class MallStyleController {
  // 图片延迟加载保存productno 和 scrolltop
  static imgTopMap = {}
  // key top -> value no
  static topImgMap = {}
  static lazyCalc = false
  static waterfallData = { styleMap: {}, height: 0, offsetTop: 0 }
  static waterfallType = ''

  static getWaterfallData () {
    return { ...this.waterfallData }
  }

  /**
   * 设置瀑布流标识区分不同瀑布流宽度计算
   */
  static setWaterfallType (type: string) {
    this.waterfallType = type
  }

  /**
   * 原始数据内加上图片宽高
   * products 需要计算的商品
   * size 分母
   * reduce 宽度偏移
   */
  static setProductImgHeight (products?: IMallViewProduct[], size: number = 2, reduce: number = 0, layout?: TMallDisplayMode) {
    return products.map((item) => {
      const itemWidth = layout === 'classicBig'
        ? (window.innerWidth - 74 - 24) / 2
        : (window.innerWidth - reduce) / size
      if (item.pic || layout === 'classicBig') {
        // 计算图片宽高
        const picWidth = Number(item.picWidth || 1)
        const picHeight = Number(item.picHeight || picWidth)
        let radio = picWidth / itemWidth
        let pw = itemWidth
        let ph = layout === 'classicBig' ? itemWidth : picHeight / radio
        return {
          ...item,
          pw,
          ph
        }
      }
      return item
    })
  }
  /** 瀑布流计算，支持计算中同时计算图片延迟加载 */
  static waterfall (products?: IMallViewProduct[], lazy = true, key: string = 'no', sourceName?: string, layout?: TMallDisplayMode) {
    const waterfallWrap = document.querySelector(`.${sourceName ? sourceName + '-' : ''}mall-waterfall-template`) as HTMLElement
    if (!waterfallWrap || !waterfallWrap.offsetWidth) {
      return
    }
    let overOff = 0
    let indexPostionMap: any = {}
    const isClassicBig = layout === 'classicBig'
    const gap = isClassicBig ? 8 : 2
    const itemWidth = isClassicBig
      ? (waterfallWrap.offsetWidth - 24) / 2
      : (waterfallWrap.offsetWidth - gap) / 2
    document.body.style.setProperty('--mallwateritemwidth', itemWidth + 'px')
    // 当前容器距离顶部的距离
    const offsetTop = (document.querySelector('.mall-product-template') as HTMLElement)?.offsetTop || 0
    let left = isClassicBig ? 8 : 0
    let top = 0 + overOff
    let lt = 0 + overOff
    let rt = 0 + overOff
    let currentCategoryNo = ''
    // 容器高度
    let maxH = 100 // 阀值100
    if (lazy) {
      this.topImgMap = {}
    }
    const productElements = products.map(product => {
      return document.getElementById(`${sourceName || 'waterfall'}product` + product[key])
    })
    if (productElements.some(element => !element || element.offsetHeight === 0)) {
      console.log('🚌 瀑布流计算失败，需要重算')
      return
    }
    const fixedItemHeight = isClassicBig
      ? Math.max(...productElements.map(element => element.offsetHeight))
      : 0
    const needReCalc = products.find((product, index) => {
      const id = product[key]
      const thisHeight = fixedItemHeight || productElements[index].offsetHeight
      const categoryNo = (product as IMallViewProduct & { categoryNo?: string }).categoryNo || ''
      if (isClassicBig && index > 0 && categoryNo !== currentCategoryNo) {
        const categoryTop = Math.max(lt, rt)
        lt = categoryTop
        rt = categoryTop
      }
      currentCategoryNo = categoryNo
      if (lt <= rt) {
        left = isClassicBig ? 8 : 0
        top = lt
        lt += thisHeight + (isClassicBig ? gap : 0)
      } else {
        left = isClassicBig ? 8 + itemWidth + gap : itemWidth + gap
        top = rt
        rt += thisHeight + (isClassicBig ? gap : 0)
      }
      indexPostionMap[id] = {
        left,
        top,
        width: itemWidth,
        height: fixedItemHeight || thisHeight,
        imgWidth: itemWidth,
      }
      if (lazy) {
        // 延迟滚动加载的方案
        if (product.hasPic) {
          this.imgTopMap[product.no] = top + offsetTop
          if (this.topImgMap[top + offsetTop]) {
            this.topImgMap[top + offsetTop + 1] = product.no
          } else {
            this.topImgMap[top + offsetTop] = product.no
          }
        }
      }
      if (maxH < top + thisHeight) {
        maxH = top + thisHeight
      }
    })
    if (needReCalc) {
      return
    }
    // console.log('🚌 瀑布流餐品位置Map', indexPostionMap)
    // console.log('🚌 Img -> Top Map', this.imgTopMap)
    // console.log('🚌 Top -> Img Map', this.topImgMap)
    // menuMobx.setStyle(indexPostionMap)
    // menuMobx.setWaterfallHeight(maxH + 10)
    // 处理完 确保计算一次滚动 主要处理未滚动就显示的case
    if (lazy) {
      this.scroll(0)
    }
    return (this.waterfallData = { styleMap: indexPostionMap, height: maxH + (isClassicBig ? 8 : 10), offsetTop })
  }
  /** 图片延迟加载 */
  static lazy (products: IMallViewProduct[]) {
    const calcLine = products.map(p => p.no).join('')
    if (lazyLine === calcLine) {
      return
    }
    this.lazyCalc = false
    this.topImgMap = {}
    products.findIndex((product, index) => {
      // 使用后计算方案
      const $productHeight = document.getElementById(restaurantConfig.displayMode + 'product' + product.no)
      // 找不到
      if (!$productHeight) {
        console.log('🚌 列表计算失败，需要重算')
        this.lazyCalc = true
        return
      }
      const thisOffsetTop: number = $productHeight.offsetTop
      if (product.hasPic) {
        this.imgTopMap[product.no] = thisOffsetTop
        if (this.topImgMap[thisOffsetTop]) {
          this.topImgMap[thisOffsetTop + 1] = product.no
        } else {
          this.topImgMap[thisOffsetTop] = product.no
        }
      }
    })
    if (!this.lazyCalc) {
      lazyLine = calcLine
      this.scroll(0)
    }
  }
  static scroll (scrollTop: number) {
    // 图片延迟加载
    if (!isEmpty(this.topImgMap)) {
      // 当前容器距离顶部的距离
      for (const key in this.topImgMap) {
        const top = parseFloat(key)
        const productNo = this.topImgMap[key]
        //  + window.innerHeight + 120
        // 添加屏幕往下200px的偏移量
        if (top < (scrollTop + window.innerHeight + 200)) {
          // console.log('🚌 延迟Image Push', productNo)
          mallMobx.setImgLoading(productNo)
          setTimeout(() => {
            delete this.topImgMap[key]
          }, 0)
        }
      }
    }
  }
  static scollToCategory (categoryNo: string) {
    if (restaurantConfig.displayMode !== 'waterfall') {
      scrollController.setForbidSearchBar(true)
      scst && clearTimeout(scst)
      const ele: HTMLElement = document.querySelector(`#category-item-${categoryNo}`)
      const topEle: HTMLElement = document.querySelector('.product-template')
      const offsetTop = ele?.offsetTop || 0
      return handleEleScrollTo?.({
        y: offsetTop + (topEle?.offsetTop || 0) - 56 - (restaurantConfig.displayMode === 'list' ? 56 : 0)
      }).then(() => {
        scst = setTimeout(() => scrollController.setForbidSearchBar(false), 800)
      }, () => {
        scrollController.setForbidSearchBar(false)
      })
    } else {
      return Promise.reject()
    }
  }

  static clearWaterfallData () {
    this.waterfallData = { styleMap: {}, height: 0, offsetTop: 0 }
  }
}

/**
 * 商城首页滚动控制
 */
export class MallScrollController {
  static isScrolling = false
  static _top: number = 0
  private static _type: string = ''
  private static mainHeight = 0
  private static productOffTop = 0
  private static contentHeight = 0
  private static ionTabbar = null
  static reset () {
    this.mainHeight = 0
    this.productOffTop = 0
    this._top = 0
  }
  static handScroll (scrollTop: number, type: '#MallWarp') {
    this._type = type
    // if (!this.mainHeight) {
    this.mainHeight = document.querySelector(type)?.clientHeight || 0
    if (!this.ionTabbar) {
      this.ionTabbar = document.querySelector('ion-tab-bar')
    }
    if (!this.productOffTop) {
      this.productOffTop = (document.querySelector('.mall-product-template') as any)?.offsetTop || 0
    }
    if (!this.ionTabbar) {
      return true
    }
    if (!this.contentHeight) {
      this.contentHeight = document.body.offsetHeight
    }
    // 边界不处理
    if (scrollTop < 0 || this.mainHeight === 0 || scrollTop + this.contentHeight >= this.mainHeight) {
      return true
    }
    // 滚动距离少于5px不处理
    if (Math.abs(scrollTop - this._top) < 5) {
      return true
    }
    if (scrollTop > this._top && ((120 + scrollTop + this.contentHeight) > this.mainHeight)) {
      if (!decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(true)
        this.ionTabbar?.classList.remove('hide')
      }
    } else if (scrollTop > this._top) {
      if (decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(false)
        this.ionTabbar?.classList.add('hide')
      }
    } else if (scrollTop < this._top) {
      if (!decorationMobx.tabBarVisible) {
        decorationMobx.setTabBarVisible(true)
        this.ionTabbar?.classList.remove('hide')
      }
    }
    // 点餐页其他连带滚动
    if (type === '#MallWarp') {
      // 桥接到controller处理图片延迟滚动加载
      mallMobx.setMallScrollTop(scrollTop)
      // MallStyleController.scroll(scrollTop)
      MallStyleController.scroll(scrollTop)
    }
    this._top = scrollTop
  }
}

/**
 * 商城支付
 */
export class MallCheckoutPayController {
  private static _cardConnectApplePaySession?: ApplePaySession
  private static _globalPaymentsApplePaySession?: ApplePaySession
  private static _stripeApplePayCallback?: (status: any) => void
  private static _asyncPayResult?: (result: any, resultOrdersId?: string) => Promise<any>
  private static _payOpenData?: { openId: string; appId?: string };
  /** 点下提交按钮，下单前 */
  static async preparePay (method?: any): Promise<void> {
    payPlanMobx.endCalc()
    try {
      await this._checkOpenId(method)
      await this._prepareBankCardOnline(method)
      await this._prepareApplePayWeb(method)
      await this._prepareAsyncPay(method)
    } catch (e) {
      payPlanMobx.beginCalc()
      throw e
    }
  }
  static async _checkOpenId (methodParam?) {
    const method = ['alipay', 'wechatPay'].includes(methodParam?.key) ? methodParam : find(
      payPlanMobx.payMethods,
      (x) => x.type === 'WechatPayWeb' || x.type === 'AlipayApp'
    )

    console.debug('checkOpenId', method)
    if (method) {
      console.debug('checkOpenId', this._payOpenData)
      if (typeof this._payOpenData?.openId !== 'string' || this._payOpenData?.openId.length < 10) {
        const obj = JSON.parse(memberMobx.thirdAuthInfo) || {}
        const { isWeixinMiniProgram } = getPlatform()
        if (isWeixinMiniProgram) {
          this._payOpenData = {
            openId: window.Config.openId,
            appId: window.Config.appId,
          }
        } else {
          this._payOpenData = {
            openId: obj.gOpenId,
          }
        }
        if (!this._payOpenData.openId) {
          this._payOpenData = await payMobx.fetchGOpenIdAndSave()
        }
      }
    }
  }

  static async _prepareBankCardOnline (methodParam?, payRechargeFlag?: boolean): Promise<void> {
    const bankCardOnlineMethod = methodParam?.key === 'bankCardOnline' ? methodParam : find(
      payPlanMobx.payMethods, (x) => x.type === 'BankCardOnline'
    ) as IBankCardOnlinePayMethod
    // 是否先校验银行卡
    const isPrepare = bankCardOnlineMethod && bankCardOnlineMethod?.channel !== 'GlobalPaymentsBankCard'

    if (isPrepare) {
      const { bankCardInfo } = bankCardOnlineMethod
      if (bankCardInfo.tokenType === 'single' && !bankCardInfo.token) {
        const card = (await modalLayer(
          BankCardAuthModal,
          { payRechargeFlag },
          'bankCardAuthModal'
        )) as ISutBankCardInfo
        if (methodParam) {
          Object.assign(methodParam, {
            bankCardInfo: card
          })
        } else {
          payPlanMobx.setBankCardInfo(card)
        }
      } else if (
        bankCardInfo.tokenType === 'multi' &&
        !bankCardInfo.creditCardNo
      ) {
        const card = (await modalLayer(
          BankCardAuthModal,
          { payRechargeFlag, multiUse: true },
          'bankCardAuthModal'
        )) as IMutBankCardInfo
        if (methodParam) {
          Object.assign(methodParam, {
            bankCardInfo: card
          })
        } else {
          payPlanMobx.setBankCardInfo(card)
        }
      }
    }
  }

  static async _prepareAsyncPay (methodParam?): Promise<void> {
    const externalPayMethod = ['alipay', 'wechatPay'].includes(methodParam?.key) ? methodParam : payPlanMobx.externalMethod

    if (externalPayMethod?.type === 'BankCardOnline' && externalPayMethod.channel === 'GlobalPaymentsBankCard') {
      this._asyncPayResult = async (result) => {
        return new Promise((resolve, reject) => {
          const { serverUrl, hppJson } = result
          modalLayer(GlobalPaymentsModal, { serverUrl, hppJson, hideLoading: true }, 'GlobalPaymentsModal')
            .then(() => {
              resolve(undefined)
            })
            .catch((error) => {
              error ? reject(new Error(error)) : reject()
            })
        })
      }
    } else if (externalPayMethod?.type === 'PayPalWeb') {
      this._asyncPayResult = async (result) => {
        if (result?.token) {
          const { env, envBo } = ENV
          const url = `https://www.${!(env === 'pro' && envBo === 'us') ? 'sandbox.' : ''}paypal.com/checkoutnow?token=${result.token}`
          window.location.href = url
          return 'async'
        }
      }
    } else if (externalPayMethod?.type === 'AlipayApp') {
      this._asyncPayResult = async (result) => {
        if (result.wapPayRequest) {
          const { wapPayRequest } = result

          let tradeNo = wapPayRequest.tradeNo || wapPayRequest.tradeNO
          // if (['ShengPayAlipayWeb', 'ShengPayAlipayWebV2'].includes(externalPayMethod.channel)) {
          //   tradeNo = wapPayRequest.tradeNO
          // }

          if (tradeNo) {
            return new Promise((resolve, reject) => {
              apConfigG.pay(tradeNo, function (resultCode) {
                if (resultCode === '9000') {
                  resolve(undefined)
                } else {
                  reject(new Error('支付宝支付错误'))
                }
              })
            })
          } else if (wapPayRequest.code) {
            throw Error(wapPayRequest.subMsg)
          }
        }
      }
    } else if (externalPayMethod?.type === 'WechatPayWeb') {
      this._asyncPayResult = async (result, resultOrdersId) => {
        const { wapPayRequest, ordersId } = result
        const { isWeixinMiniProgram, isWeixinBrower } = getPlatform()
        if (['ShengPayWechatWeb', 'ShengPayWechatWebV2'].includes(externalPayMethod.channel)) {
          wapPayRequest.package = wapPayRequest.packageStr || wapPayRequest.package
        }
        if (isWeixinMiniProgram) {
          let _url = `/pages/pay/index?p=${encodeURIComponent(JSON.stringify(wapPayRequest))}&o=${ordersId}&scene=mall`
          if (resultOrdersId) {
            _url += `&ro=${resultOrdersId}`
          }
          miniAppRouteTo({
            url: _url
          })
        } else if (isWeixinBrower) {
          return new Promise((resolve, reject) => {
            window.WeixinJSBridge.invoke('getBrandWCPayRequest', wapPayRequest, function (res) {
              if (res.err_msg !== 'get_brand_wcpay_request:ok') {
                reject(new Error('用户取消'))
              }
              resolve(undefined)
            })
          })
        } else {
          throw new Error('Not in weixin mini program or browser.')
        }
      }
    }
  }

  static async _prepareApplePayWeb (methodParam?): Promise<void> {
    const applePayWebMethod = methodParam?.key === 'applePay' ? methodParam : find(
      payPlanMobx.payMethods,
      (x) => x.type === 'ApplePayWeb'
    ) as IApplePayWebPayMethod
    if (applePayWebMethod) {
      const { channel } = applePayWebMethod
      if (channel === 'CardConnectApplePay' || channel === 'GlobalPaymentsApplePay') {
        let method: ICardConnectApplePayWebPayMethod | IGlobalPaymentsApplePayWebPayMethod
        if (channel === 'CardConnectApplePay') {
          method = applePayWebMethod as ICardConnectApplePayWebPayMethod
        } else if (channel === 'GlobalPaymentsApplePay') {
          method = applePayWebMethod as IGlobalPaymentsApplePayWebPayMethod
        }
        const { cardInfo } = method
        if (!cardInfo) {
          const total: ApplePayJS.ApplePayLineItem = {
            type: 'final',
            label: storeMobx.info.storeName,
            amount: String(method.amount),
          }
          return new Promise((resolve, reject) => {
            const session = new ApplePaySession(3, {
              countryCode: 'US',
              currencyCode: 'USD',
              supportedNetworks: ['amex', 'visa', 'masterCard', 'discover'],
              merchantCapabilities: ['supports3DS'],
              total,
            })
            session.onvalidatemerchant = async function (event) {
              console.log('onvalidatemerchant', event)
              try {
                const { result } = (await PayApi.applePayMerchantValidate({
                  orderSource: 'dt',
                  useType: 'mall',
                  storeId: storeMobx.info.storeId,
                  validationURL: event.validationURL,
                })) as any
                console.log('validate result', result)
                session.completeMerchantValidation(result)
              } catch (e) {
                session.abort()
                reject(e)
              }
            }
            session.onpaymentmethodselected = async function (event) {
              console.log('onpaymentmethodselected', event)
              session.completePaymentMethodSelection({ newTotal: total })
            }
            session.onpaymentauthorized = async function (event) {
              console.log('onpaymentauthorized', event)
              const { paymentData } = event.payment.token
              const { data, header, signature, version } = paymentData
              const { ephemeralPublicKey, publicKeyHash, transactionId } =
                header
              payPlanMobx.setMethodCardInfo({
                data,
                signature,
                version,
                ephemeralPublicKey,
                publicKeyHash,
                transactionId,
              })
              resolve()
            }
            session.oncancel = function () {
              console.log('oncancel')
              reject('cancel')
            }
            if (channel === 'CardConnectApplePay') {
              this._cardConnectApplePaySession = session
            } else if (channel === 'GlobalPaymentsApplePay') {
              this._globalPaymentsApplePaySession = session
            }
            session.begin()
          })
        }
      } else if (channel === 'StripeApplePay') {
        const method = applePayWebMethod as IStripeApplePayWebPayMethod
        const { cardInfo } = method
        if (!cardInfo) {
          return new Promise((resolve, reject) => {
            const Stripe = (window as any).Stripe
            Stripe.setPublishableKey(
              payChannelMobx.channelAccount.StripeApplePay?.publicApiKey
            )
            const paymentRequest = {
              countryCode: 'US',
              currencyCode: 'USD',
              total: {
                label: storeMobx.info.storeName,
                amount: String(method.amount),
              },
            }
            const session = Stripe.applePay.buildSession(
              paymentRequest,
              (result, completion) => {
                payPlanMobx.setMethodCardInfo({ auth_code: result.token.id })
                this._stripeApplePayCallback = completion
                resolve()
              },
              reject
            )
            session.oncancel = function () {
              console.log('oncancel')
              reject('cancel')
            }
            session.begin()
          })
        }
      }
    }
  }

  static async _saveBankCard (methodParam?): Promise<void> {
    const bankCardOnlineMethod = methodParam?.key === 'bankCardOnline' ? methodParam : find(
      payPlanMobx.payMethods,
      (x) => x.type === 'BankCardOnline'
    ) as IBankCardOnlinePayMethod
    if (bankCardOnlineMethod) {
      const { bankCardInfo } = bankCardOnlineMethod
      if (bankCardInfo.tokenType === 'multi') {
        bankCardMobx.setLastUsed(bankCardInfo)
      }
    }
  }

  /** 下单并发起支付后，真正执行支付 */
  static async doPay (prepayCreate: IPrepayCreate): Promise<void | 'async'> {
    this._saveBankCard()
    try {
      await this._lock(prepayCreate)
      const settelResult = await this._settle(prepayCreate)
      if (this._cardConnectApplePaySession) {
        this._cardConnectApplePaySession.completePayment(
          (window as any).ApplePaySession.STATUS_SUCCESS
        )
      }
      if (this._globalPaymentsApplePaySession) {
        this._globalPaymentsApplePaySession.completePayment(
          (window as any).ApplePaySession.STATUS_SUCCESS
        )
      }
      if (this._stripeApplePayCallback) {
        this._stripeApplePayCallback(
          (window as any).ApplePaySession.STATUS_SUCCESS
        )
      }
      if (this._payOpenData) {
        this._payOpenData = undefined
      }
      if (this._asyncPayResult) {
        setTimeout(() => {
          memberMobx.refreshMemeberBenefits()
        }, 1000)
        return await this._asyncPayResult(settelResult)
      }
    } catch (e) {
      if (this._cardConnectApplePaySession) {
        this._cardConnectApplePaySession.abort()
      }
      if (this._globalPaymentsApplePaySession) {
        this._globalPaymentsApplePaySession.abort()
      }
      if (this._stripeApplePayCallback) {
        this._stripeApplePayCallback(
          (window as any).ApplePaySession.STATUS_FAILURE
        )
      }
      if (this._asyncPayResult) {
        this._asyncPayResult = undefined
      }
      throw e
    }
  }

  static async _lock (prepayCreate: IPrepayCreate): Promise<void> {
    if (!prepayCreate.clientNumber) {
      const { error } = (await PayApi.lockPreCreate(
        prepayCreate.prepayCreateId,
        prepayCreate.ordersId,
        appMobx.deviceId,
        true
      )) as any
      if (error) {
        throw error
      }
    } else if (prepayCreate.clientNumber !== appMobx.deviceId) {
      throw new Error(i18n.t('pay.payingByOther'))
    }
  }

  static async _settle (prepayCreate: IPrepayCreate): Promise<void> {
    const {
      prepayCreateId,
      storeId,
      ordersId,
      clientNumber,
      amount,
      amountTax,
      amountService,
    } = prepayCreate

    if (
      toDecimal(amount, 2, true) !== toDecimal(payPlanMobx.orderAmount, 2, true)
    ) {
      throw new Error(
        `订单金额不一致，下单前：${payPlanMobx.orderAmount}，下单后：${amount}`
      )
    }
    function getReturnUrl (method: TPayMethod) {
      if (method.type === 'PayPalWeb') {
        return `${getHandTopUrl()}/paypalreturn/${ordersId}${location.search}`
      }
    }
    // 更新方案订单信息，避免失败后由于下单前订单信息与下单后订单信息不一致，导致方案从头重新计算
    // payPlanMobx.updateOrder({
    //   type: 'dining',
    //   uniqueKey: ordersId,
    //   subtotal: toDecimal(amount - amountTax - amountService, 2, true) as number,
    //   tax: amountTax,
    //   extraFee: amountService,
    // })
    let channels: IBatchPayChannelParam[]
    if (payPlanMobx.totalAmount > 0) {
      channels = await Promise.all(
        map(payPlanMobx.payMethods, async (x) => {
          const ext = {} as Record<string, string | number>
          let isSurcharge = false
          if (x.type === 'MemberCard') {
            ext.cardId = x.memberCard.cardId
            ext.cardNumber = x.memberCard.cardNo
            ext.memberId = memberMobx.memberInfo.memberId
            ext.token = memberMobx.token
          } else if (x.type === 'GiftCard') {
            ext.cardId = x.giftCard.giftcardId
            ext.cardNumber = x.giftCard.cardNo
            ext.token = memberMobx.token
          } else if (x.type === 'BankCardOnline') {
            if (x.bankCardInfo.tokenType === 'single') {
              ext.authCode = x.bankCardInfo.token
            } else if (x.bankCardInfo.tokenType === 'multi') {
              ext.creditCardNo = x.bankCardInfo.creditCardNo
            }
            isSurcharge = x.bankCardInfo?.creditCardType !== 'N'
          } else if (x.type === 'ApplePayWeb') {
            if (x.cardInfo) {
              Object.assign(ext, x.cardInfo)
            }
          } else if (x.type === 'PayPalWeb') {
            ext.returnUrl = getReturnUrl(x)
          } else if (x.type === 'AlipayApp') {
            let buyerId = this._payOpenData?.openId
            if (isEmpty(buyerId)) {
              console.debug('buyerId', buyerId)
              PayApi.openIdErrorDingTalkSend(ordersId, this._payOpenData?.openId)
              throw new Error('发起支付宝支付失败,请重新扫码打开')
            }
            Object.assign(ext, { buyerId })
          } else if (x.type === 'WechatPayWeb') {
            const { isWeixinMiniProgram, isWeixinBrower } = getPlatform()
            let appId, openId
            if (isWeixinMiniProgram) {
              appId = this._payOpenData?.appId
              openId = this._payOpenData?.openId
            } else if (isWeixinBrower) {
              openId = this._payOpenData?.openId
            }
            if (isEmpty(openId)) {
              console.debug('openId', openId)
              PayApi.openIdErrorDingTalkSend(ordersId, this._payOpenData?.openId)
              throw new Error(`发起微信支付失败,请${isWeixinMiniProgram ? '删掉小程序,然后' : ''}重新扫码打开`)
            }
            Object.assign(ext, { appId, openId })
          }
          // 附加费
          const surchargeConfig = surchargeMobx.surchargeMap?.[x.channel]
          const surchargeInfo: any = {}
          if (isSurcharge && surchargeConfig) {
            const surcharge = toDecimal(x.amount * (surchargeConfig.rate / 100), 2, true)
            if (surcharge) {
              surchargeInfo.surcharge = surcharge
              surchargeInfo.paymentSurchargeConfigUuid = surchargeConfig.id
              surchargeInfo.surchargeName = surchargeConfig.name
              surchargeInfo.surchargeRate = surchargeConfig.rate
            }
          }
          return {
            requestId: uuid(),
            channelType: x.channel,
            amount: toDecimal(x.amount, 2, true),
            tip: toDecimal(x.tip, 2, true),
            ext,
            ...surchargeInfo
          }
        })
      )
      channels = filter(channels, (x) => Number(x.amount) + Number(x.tip) > 0)
    } else {
      channels = [{
        requestId: uuid(),
        channelType: 'ZeroPay',
        amount: 0,
        tip: 0,
        ext: {}
      }]
    }

    const currency = channels?.some(c => c.channelType === 'GlobalPaymentsBankCard') ? 'CAD' : 'USD'
    const { error, result } = (await PayApi.batchPay({
      bo,
      prepayCreateId,
      clientNumber,
      orderSource: 'dt',
      useType: 'mall',
      storeId,
      currency,
      // 支付宝支付时，需要传入appId
      opAppId: Config.appId || '',
      requestId: uuid(),
      ordersId,
      channels,
      ext: {
        deviceType: 'mobile',
        deviceId: appMobx.deviceId,
      },
    })) as any

    if (error) {
      throw error
    }
    payPlanMobx.clear()
    return result
  }
  static async resume (
    orderId: string
  ): Promise<'CANCEL' | 'SUCCESS' | 'PAYING'> {
    if (!orderId) {
      throw new Error('orderId is required to resume.')
    }
    const { result, error } = (await PayApi.preByOrdersId(orderId)) as any
    if (error) {
      throw error
    }
    const prepayCreate = result as IPrepayCreate
    if (!prepayCreate) {
      // 不需要报错
      return
      // throw new Error(`Cannot find prepay create for ${orderId}`)
    }
    const { prepayCreateId, clientNumber, status } = prepayCreate
    if (status === 'Success') {
      return 'SUCCESS'
    } else if (status === 'Closed') {
      return 'CANCEL'
    } else {
      const { error } = (await PayApi.cancelPay(
        prepayCreateId,
        appMobx.deviceId || clientNumber,
        orderId
      )) as any
      if (error) {
        // TODO: 付到一半没办法从手机端取消
        throw error
      }
      return 'CANCEL'
    }
  }
  static holdAsyncOrder (ordersId) {
    const payStore = store.namespace('pay')
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    payStore.set('asyncPayOrdersId.' + ordersId, 'async')
  }
  static clearHoldAsync (ordersId) {
    const payStore = store.namespace('pay')
    payStore.remove('asyncPayOrdersId.' + ordersId)
  }
  static isOrderAsync (ordersId) {
    const payStore = store.namespace('pay')
    const value = payStore.get('asyncPayOrdersId.' + ordersId)
    return value === 'async'
  }

  static async preOrdersBatchPay (method: any): Promise<any> {
    try {
      await this._checkOpenId(method)
      await this._prepareBankCardOnline(method, true)
      await this._prepareApplePayWeb(method)
      await this._prepareAsyncPay(method)
      return method
    } catch (e) {
      reject(e)
    }
  }

  static async ordersBatchPay (method: any, orders: any[]) {
    if (method?.key === 'bankCardOnline') {
      this._saveBankCard(method)
    }
    const orderArr = orders.map(order => {
      const saveOrder = {
        ...order,
        channels: [...order.channels.map(c => {
          return { ...c, requestId: uuid() }
        })],
        ext: {
          deviceType: 'mobile',
          deviceId: restaurantConfig.deviceId,
        },
        clientNumber: restaurantConfig.deviceId,
        bo
      }
      return saveOrder
    })
    const { error, result } = (await OrderAPI.batchOrdersPay(orderArr))
    if (error) {
      if (this._cardConnectApplePaySession) {
        this._cardConnectApplePaySession.abort()
      }
      if (this._globalPaymentsApplePaySession) {
        this._globalPaymentsApplePaySession.abort()
      }
      if (this._stripeApplePayCallback) {
        this._stripeApplePayCallback(
          (window as any).ApplePaySession.STATUS_FAILURE
        )
      }
      if (this._asyncPayResult) {
        this._asyncPayResult = undefined
      }
      throw error
    }
    payPlanMobx.clear()
    if (this._cardConnectApplePaySession) {
      this._cardConnectApplePaySession.completePayment(
        (window as any).ApplePaySession.STATUS_SUCCESS
      )
    }
    if (this._globalPaymentsApplePaySession) {
      this._globalPaymentsApplePaySession.completePayment(
        (window as any).ApplePaySession.STATUS_SUCCESS
      )
    }
    if (this._stripeApplePayCallback) {
      this._stripeApplePayCallback(
        (window as any).ApplePaySession.STATUS_SUCCESS
      )
    }
    if (this._payOpenData) {
      this._payOpenData = undefined
    }
    if (this._asyncPayResult) {
      setTimeout(() => {
        memberMobx.refreshMemeberBenefits()
      }, 1000)
      return await this._asyncPayResult(result, orderArr[1]?.ordersId)
    }
    return result
  }
}

/**
 * 订单重置
 */
export class MallRestoreOrderController {
  private static isThisTime = false
  static localKey () {
    return `mallOrder.pendingOrdersId.${restaurantConfig.brandId || Config.BRANDID}`
  }
  static async restore (fromPayfail: boolean = false) {
    if (this.isThisTime) {
      return
    }
    this.isThisTime = true
    const pendingOrdersId = store.get(this.localKey())
    let fetchOrder = null
    if (!pendingOrdersId) {
      try {
        // TODO 支持获取订单详情
        const order = restaurantConfig.codeType === 'table' && storeMobx.info.openMultiPersonOrdering ? await orderListMobx.getFirstTabelCodeOrder(restaurantConfig.tableCode.toString()) : await orderListMobx.getFirstPayingOrder()
        if (order) {
          fetchOrder = order
        }
      } catch (error) {

      }
    }
    if (!pendingOrdersId && !fetchOrder) {
      return
    }
    // 需要先清除原先的购物车的数据确保 购物车当前没数据
    cartMobx.safeClear()
    await cartMobx.setOrdersId(fetchOrder ? fetchOrder.ordersId : pendingOrdersId)
    const order = orderMobx.viewOrder
    // 判断当前这个订单是否可用
    if (order.status === 'Pending' || order.status === 'Paying' || order.status === 'NotAccepted') {
      const history = getHistoryNew()
      // 如果不在点餐页、支付失败页
      if (!fromPayfail && history.location.pathname !== '/menu') {
        return
      }
      modalLayer.closeAll()
      if (fromPayfail) {
        this.checkout(fromPayfail)
        return
      }
      return modalLayer(ConfirmModal, {
        title: i18n.t('common.attention'),
        confirmText: i18n.t('menu.go_pay'),
        canClose: false,
        backdropDismiss: false,
        children: i18n.t('menu.you_has_unpay_bill', { price: order.paidFee }),
        cancelText: i18n.t('menu.continue_shop'),
        className: 'cart-confirm-modal'
      }, 'restoreOrderModal').then((res: any) => {
        this.checkout()
      }).catch(async (res: any) => {
        if (res) {
          store.remove(this.localKey())
          cartMobx.reset(cartMobx.info.eatType)
        } else {
        // do nothing
        }
        // 关闭等待支付的订单
        if (order.status === 'Paying') {
          await MallCheckoutPayController.resume(order.ordersId)
        }
        orderMobx.cancel()
      })
    } else {
      // 如果订单无效也需要清理掉订单中的数据
      orderMobx.reset()
      cartMobx.clearOrdersId()
      this.clearHold()
    }
  }
  static hold (ordersId) {
    store.set(this.localKey(), ordersId)
    this.tempHold(ordersId)
    this.isThisTime = true
  }
  static clearHold () {
    store.remove(this.localKey())
  }
  static async checkout (fromPayfail: boolean = false) {
    const history = getHistoryNew()
    if (orderMobx.order.ordersId) {
      // 关闭等待支付的订单
      if (orderMobx.order.status === 'Paying') {
        MallCheckoutPayController.resume(orderMobx.order.ordersId)
      }
      if (orderMobx.order.payMode) {
        cartMobx.setOrder()
      } else {
        cartMobx.restoreOrderToCart()
      }
      !fromPayfail && history.push('/mcheckout')
    }
  }
  static tempHold (ordersId) {
    const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
    if (isWeixinMiniProgram || isAliPayMiniProgram) {
      setCookie(this.localKey(), ordersId, Date.now() + 60000)
    }
  }
  static getTempHold () {
    return getCookie(this.localKey())
  }
}

/**
 * 商城通用
 */
export class MallController {
  static goToProduct (product: IMallViewProduct | IViewCartItem, isAdd: boolean = false) {
    const history = getHistoryNew()
    const productNo = (product as IMallViewProduct).no || (product as IViewCartItem).productNo
    doProductMobx.pick({ product: product as IMallViewProduct, productNo: (product as IMallViewProduct).no })
    if (isAdd) {
      history.replace(`/mproduct/${productNo}`)
    } else {
      history.push(`/mproduct/${productNo}`)
    }
  }
  static async getRecommendProduct (productNo: string) {
    const res = await ProductAPI.getRecommendProduct(productNo)
    if (!res) {
      return []
    }
    let { recommend_products = [] } = res
    // 筛选出可以单独购买，上架，有库存的商品
    let recommendProducts = []
    recommend_products.forEach(item => {
      const viewProduct = productMobx.noToViewProductMap[item]
      if (viewProduct && viewProduct.isNotSingleInCombo && !viewProduct.disable && viewProduct.saleCnt !== 0) {
        recommendProducts.push(viewProduct)
      }
    })
    return recommendProducts
  }

  /**
   * 从缓存还原商城购物车
   * isSave boolean 是否需要存到购物车
  */
  static restoreCartFromStorage (isSave: boolean = true) {
    const Cart = shopcartCache.getCart()
    if (isSave && Cart) {
      // 如果存在购物车
      shopcartMobx.restoreCart(Cart)
    }
    return Cart || []
  }

  /** 选择商品弹层 */
  static showProductScaleModal (product: IMallCartItem | IMallDoProduct) {
    // 非购物车不允许修改结算页商品规格
    if (!shopcartMobx.isTarget) return
    product.pk && doProductMobx.pick({ cartItemPk: product.pk })
    modalLayer(ScaleModal, { cartItemPk: product.pk, payType: shopcartMobx.isTarget ? TCheckoutType.Cart : TCheckoutType.Buy }, 'ScaleModal').then((res: any) => {
      cartMobx.addToCart(res.product)
    }).catch(() => {
    })
  }

  /** 跳转结算页 判断是否同步购物车数据 */
  static goCheckout (type: TCheckoutType = TCheckoutType.Buy) {
    const history = getHistoryNew()
    if (type === TCheckoutType.Cart) {
      // 将购物车数据差人结算页
      shopcartMobx.addShopCartToCheckout()
    }
    history.push('/mcheckout')
  }

  /** 退出购物车清空结算页数据 */
  static outCheckout () {
    shopcartMobx.setTarget(false)
    cartMobx.safeClear()
  }
}
